var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var VIDEO_FILE_REGEX = /\.(mp4|webm|ogg|mov|avi|m4v)(\?.*)?$/i;
var URL_REGEX = /(https?:\/\/[^\s<>"']+)/gi;
var VIDEO_TEXT_SKIP_TAGS = new Set(['IFRAME', 'VIDEO', 'SCRIPT', 'STYLE', 'A']);
var SEARCH_SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'VIDEO', 'MARK']);
var isVideoFile = function isVideoFile(url) {
    return VIDEO_FILE_REGEX.test(url);
};
var buildYoutubeEmbedUrl = function buildYoutubeEmbedUrl(id) {
    return id ? "https://www.youtube.com/embed/".concat(id) : null;
};
var getFirstPathSegment = function getFirstPathSegment(pathname) {
    var _pathname$split$find;
    return (_pathname$split$find = pathname.split('/').find(Boolean)) !== null && _pathname$split$find !== void 0 ? _pathname$split$find : null;
};
var getSegmentAfterPrefix = function getSegmentAfterPrefix(pathname, prefix) {
    var _pathname$split$1$spl, _pathname$split$;
    return (_pathname$split$1$spl = (_pathname$split$ = pathname.split(prefix)[1]) === null || _pathname$split$ === void 0 ? void 0 : _pathname$split$.split('/')[0]) !== null && _pathname$split$1$spl !== void 0 ? _pathname$split$1$spl : null;
};
var getYoutubeEmbedUrl = function getYoutubeEmbedUrl(url) {
    try {
        var parsed = new URL(url);
        var hostname = parsed.hostname, pathname = parsed.pathname, searchParams = parsed.searchParams;
        if (hostname.includes('youtu.be')) {
            return buildYoutubeEmbedUrl(getFirstPathSegment(pathname));
        }
        if (!hostname.includes('youtube.com')) {
            return null;
        }
        if (pathname === '/watch') {
            return buildYoutubeEmbedUrl(searchParams.get('v'));
        }
        if (pathname.startsWith('/embed/')) {
            return url;
        }
        if (pathname.startsWith('/live/')) {
            return buildYoutubeEmbedUrl(getSegmentAfterPrefix(pathname, '/live/'));
        }
        if (pathname.startsWith('/shorts/')) {
            return buildYoutubeEmbedUrl(getSegmentAfterPrefix(pathname, '/shorts/'));
        }
        return null;
    }
    catch (_unused) {
        return null;
    }
};
var createResponsiveWrapper = function createResponsiveWrapper(doc) {
    var wrapper = doc.createElement('div');
    wrapper.setAttribute('style', 'position: relative; width: 100%; padding-bottom: 56.25%; height: 0; margin: 16px 0; overflow: hidden; border-radius: 8px;');
    return wrapper;
};
var createIframeElement = function createIframeElement(doc, src, title) {
    var iframe = doc.createElement('iframe');
    iframe.src = src;
    iframe.title = title;
    iframe.loading = 'lazy';
    iframe.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0; border-radius: 8px;');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return iframe;
};
var createYoutubeIframe = function createYoutubeIframe(doc, embedUrl) {
    var wrapper = createResponsiveWrapper(doc);
    var iframe = createIframeElement(doc, embedUrl, 'YouTube video player');
    wrapper.appendChild(iframe);
    return wrapper;
};
var createVideoPlayer = function createVideoPlayer(doc, url) {
    var video = doc.createElement('video');
    video.src = url;
    video.controls = true;
    video.preload = 'metadata';
    video.setAttribute('style', 'width: 100%; max-width: 100%; margin: 16px 0; border-radius: 8px; display: block;');
    video.setAttribute('playsinline', 'true');
    video.setAttribute('controlsList', 'nodownload');
    return video;
};
var isSharePointHost = function isSharePointHost(hostname) {
    return hostname.includes('sharepoint.com') || hostname.includes('sharepoint-df.com');
};
var isLikelySharePointVideoUrl = function isLikelySharePointVideoUrl(url) {
    try {
        var _URL = new URL(url), hostname = _URL.hostname, pathname = _URL.pathname, searchParams = _URL.searchParams;
        if (!isSharePointHost(hostname)) {
            return false;
        }
        return pathname.includes('/_layouts/15/embed.aspx') || pathname.includes('/stream.aspx') || pathname.includes('/:v:/') || searchParams.has('UniqueId') || searchParams.has('uniqueId');
    }
    catch (_unused2) {
        return false;
    }
};
var getSharePointEmbedUrl = function getSharePointEmbedUrl(url) {
    try {
        var _search$get;
        var parsed = new URL(url);
        if (!isSharePointHost(parsed.hostname)) {
            return null;
        }
        var pathname = parsed.pathname.toLowerCase();
        var search = parsed.searchParams;
        // Already embeddable
        if (pathname.includes('/_layouts/15/embed.aspx') || ((_search$get = search.get('action')) === null || _search$get === void 0 ? void 0 : _search$get.toLowerCase()) === 'embedview') {
            return parsed.toString();
        }
        // Common video share link
        if (pathname.includes('/:v:/')) {
            search.set('action', 'embedview');
            return parsed.toString();
        }
        // Direct .mp4 file hosted in SharePoint
        if (pathname.endsWith('.mp4') || pathname.endsWith('.webm') || pathname.endsWith('.ogg') || pathname.endsWith('.mov') || pathname.endsWith('.m4v')) {
            return parsed.toString();
        }
        // Some SharePoint/OneDrive sharing links still preview correctly with embedview
        search.set('action', 'embedview');
        return parsed.toString();
    }
    catch (_unused3) {
        return null;
    }
};
var createSharePointIframe = function createSharePointIframe(doc, embedUrl) {
    var wrapper = createResponsiveWrapper(doc);
    var iframe = createIframeElement(doc, embedUrl, 'SharePoint video player');
    iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
    wrapper.appendChild(iframe);
    return wrapper;
};
var createSharePointLink = function createSharePointLink(doc, originalUrl) {
    var wrapper = doc.createElement('div');
    wrapper.setAttribute('style', 'display: inline-flex; align-items: center; gap: 8px; margin: 16px 0; padding: 12px 20px; background: #f3f2f1; border: 1px solid #e1dfdd; border-radius: 8px;');
    var icon = doc.createElement('span');
    icon.textContent = '▶';
    icon.setAttribute('style', 'font-size: 18px; color: #0078d4;');
    var link = doc.createElement('a');
    link.href = originalUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Open SharePoint video';
    link.setAttribute('style', 'color: #0078d4; font-weight: 600; text-decoration: none; font-size: 15px;');
    wrapper.appendChild(icon);
    wrapper.appendChild(link);
    return wrapper;
};
var trimTrailingPunctuation = function trimTrailingPunctuation(url) {
    var TRAILING_PUNCTUATION = ')].,!?:;';
    var splitIndex = url.length;
    while (splitIndex > 0 && TRAILING_PUNCTUATION.includes(url[splitIndex - 1])) {
        splitIndex -= 1;
    }
    if (splitIndex === url.length) {
        return {
            cleanUrl: url,
            trailing: ''
        };
    }
    var trailing = url.slice(splitIndex);
    var cleanUrl = url.slice(0, splitIndex);
    return {
        cleanUrl: cleanUrl,
        trailing: trailing
    };
};
var createMediaNodeForUrl = function createMediaNodeForUrl(doc, rawUrl) {
    var _trimTrailingPunctuat = trimTrailingPunctuation(rawUrl), cleanUrl = _trimTrailingPunctuat.cleanUrl;
    var youtubeEmbedUrl = getYoutubeEmbedUrl(cleanUrl);
    if (youtubeEmbedUrl) {
        return createYoutubeIframe(doc, youtubeEmbedUrl);
    }
    var sharePointEmbedUrl = getSharePointEmbedUrl(cleanUrl);
    if (sharePointEmbedUrl) {
        return createSharePointIframe(doc, sharePointEmbedUrl);
    }
    if (isLikelySharePointVideoUrl(cleanUrl)) {
        return createSharePointIframe(doc, cleanUrl);
    }
    if (isSharePointHostSafe(cleanUrl)) {
        return createSharePointLink(doc, cleanUrl);
    }
    if (isVideoFile(cleanUrl)) {
        return createVideoPlayer(doc, cleanUrl);
    }
    return null;
};
var isSharePointHostSafe = function isSharePointHostSafe(url) {
    try {
        return isSharePointHost(new URL(url).hostname);
    }
    catch (_unused4) {
        return false;
    }
};
var replaceAnchorLinks = function replaceAnchorLinks(doc) {
    var links = Array.from(doc.querySelectorAll('a'));
    for (var _i = 0, _links = links; _i < _links.length; _i++) {
        var link = _links[_i];
        var href = (link.getAttribute('href') || '').trim();
        var text = (link.textContent || '').trim();
        var candidateUrls = [href, text].filter(Boolean);
        var mediaNode = candidateUrls.reduce(function (found, url) {
            return found !== null && found !== void 0 ? found : createMediaNodeForUrl(doc, url);
        }, null);
        if (mediaNode) {
            link.replaceWith(mediaNode);
        }
    }
};
var replacePlainTextUrlsInTextNode = function replacePlainTextUrlsInTextNode(doc, textNode) {
    var _textNode$parentNode;
    var text = textNode.textContent || '';
    URL_REGEX.lastIndex = 0;
    if (!URL_REGEX.test(text)) {
        return;
    }
    URL_REGEX.lastIndex = 0;
    var fragment = doc.createDocumentFragment();
    var lastIndex = 0;
    var match;
    while ((match = URL_REGEX.exec(text)) !== null) {
        var _createMediaNodeForUr;
        var matchedUrl = match[0];
        var start = match.index;
        var _trimTrailingPunctuat2 = trimTrailingPunctuation(matchedUrl), cleanUrl = _trimTrailingPunctuat2.cleanUrl, trailing = _trimTrailingPunctuat2.trailing;
        if (start > lastIndex) {
            fragment.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
        }
        fragment.appendChild((_createMediaNodeForUr = createMediaNodeForUrl(doc, cleanUrl)) !== null && _createMediaNodeForUr !== void 0 ? _createMediaNodeForUr : doc.createTextNode(cleanUrl));
        if (trailing) {
            fragment.appendChild(doc.createTextNode(trailing));
        }
        lastIndex = start + matchedUrl.length;
    }
    if (lastIndex < text.length) {
        fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }
    (_textNode$parentNode = textNode.parentNode) === null || _textNode$parentNode === void 0 || _textNode$parentNode.replaceChild(fragment, textNode);
};
var _replacePlainTextUrls = function replacePlainTextUrls(doc, node) {
    if (node.nodeType === Node.TEXT_NODE) {
        replacePlainTextUrlsInTextNode(doc, node);
        return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
    }
    var element = node;
    if (VIDEO_TEXT_SKIP_TAGS.has(element.tagName)) {
        return;
    }
    for (var _i2 = 0, _Array$from = Array.from(node.childNodes); _i2 < _Array$from.length; _i2++) {
        var childNode = _Array$from[_i2];
        _replacePlainTextUrls(doc, childNode);
    }
};
export var convertVideoLinksToPlayers = function convertVideoLinksToPlayers(htmlContent) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlContent, 'text/html');
    replaceAnchorLinks(doc);
    for (var _i3 = 0, _Array$from2 = Array.from(doc.body.childNodes); _i3 < _Array$from2.length; _i3++) {
        var childNode = _Array$from2[_i3];
        _replacePlainTextUrls(doc, childNode);
    }
    return doc.body.innerHTML;
};
var SEARCH_HIGHLIGHT_ATTR = 'data-search-highlight';
var unwrapHighlightMarks = function unwrapHighlightMarks(root) {
    var marks = root.querySelectorAll("mark[".concat(SEARCH_HIGHLIGHT_ATTR, "=\"true\"]"));
    for (var _i4 = 0, _Array$from3 = Array.from(marks); _i4 < _Array$from3.length; _i4++) {
        var mark = _Array$from3[_i4];
        var parent = mark.parentNode;
        if (!parent) {
            continue;
        }
        while (mark.firstChild) {
            parent.insertBefore(mark.firstChild, mark);
        }
        mark.remove();
        parent.normalize();
    }
};
var createHighlightedFragment = function createHighlightedFragment(doc, text, regex) {
    regex.lastIndex = 0;
    if (!regex.test(text)) {
        return null;
    }
    regex.lastIndex = 0;
    var fragment = doc.createDocumentFragment();
    var lastIndex = 0;
    var match;
    while ((match = regex.exec(text)) !== null) {
        var start = match.index;
        var matchedText = match[0];
        if (start > lastIndex) {
            fragment.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
        }
        var mark = doc.createElement('mark');
        mark.setAttribute(SEARCH_HIGHLIGHT_ATTR, 'true');
        mark.textContent = matchedText;
        fragment.appendChild(mark);
        lastIndex = start + matchedText.length;
    }
    if (lastIndex < text.length) {
        fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }
    return fragment;
};
var shouldSkipSearchHighlight = function shouldSkipSearchHighlight(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    return SEARCH_SKIP_TAGS.has(node.tagName);
};
export var highlightSearchInElement = function highlightSearchInElement(root, term) {
    unwrapHighlightMarks(root);
    var search = term.trim();
    if (!search) {
        return;
    }
    var escaped = search.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["$&"], ["\\$&"]))));
    var regex = new RegExp(escaped, 'gi');
    var doc = root.ownerDocument;
    var highlightTextNode = function highlightTextNode(textNode) {
        var _textNode$parentNode2;
        var text = textNode.textContent || '';
        if (!text) {
            return;
        }
        var fragment = createHighlightedFragment(doc, text, regex);
        if (!fragment) {
            return;
        }
        (_textNode$parentNode2 = textNode.parentNode) === null || _textNode$parentNode2 === void 0 || _textNode$parentNode2.replaceChild(fragment, textNode);
    };
    var _walk = function walk(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            highlightTextNode(node);
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE || shouldSkipSearchHighlight(node)) {
            return;
        }
        for (var _i5 = 0, _Array$from4 = Array.from(node.childNodes); _i5 < _Array$from4.length; _i5++) {
            var childNode = _Array$from4[_i5];
            _walk(childNode);
        }
    };
    for (var _i6 = 0, _Array$from5 = Array.from(root.childNodes); _i6 < _Array$from5.length; _i6++) {
        var childNode = _Array$from5[_i6];
        _walk(childNode);
    }
};
